module.exports = __webpack_public_path__ + "static/Fisherman-Text-White-Logo.3104c988.png";


//////////////////
// WEBPACK FOOTER
// ./~/@fishrmn/fishrmn-components/build/components/molecules/FishermanLabel/Fisherman-Text-White-Logo.png
// module id = 1035
// module chunks = 168707334958949